module.exports = __webpack_public_path__ + "img/mx-o.b868de39.svg";